/**
 * FieldValidationType
 *
 * @hidden
 * Should match server enum found at /EE.Api/DB/Enums.cs
 */
export enum FieldValidationType {
    none = -1,
    email = 0,
    usMobilePhone = 1,
    address = 2,
    date = 3,
    other = 4,
    dollars = 5,
    years = 6,
}
